// extracted by mini-css-extract-plugin
export default {"Overlay":"LoadingModal_Overlay__+2H7y","ModalBody":"LoadingModal_ModalBody__vE6AN"};